import { Injectable, inject } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { UserLoginService } from './user-login.service';
import { BehaviorSubject, from } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SignalrTransactionUploadsService {
  private userService = inject(UserLoginService);

  public transactionUploadsConnected = new BehaviorSubject<boolean>(false);

  public transactionUploads = new BehaviorSubject<any[]>([]);
  private transactionUploadsHub: string = `/transaction_uploads_hub`;

  private transactionUploadsConnection: any;

  public async connectTransactionUploadsHub(): Promise<void> {
    this.userService.auth.getAccessTokenSilently({ detailedResponse: true }).subscribe(async (token) => {
      const idToken = token.access_token;
      try {
        this.transactionUploadsConnection = new signalR.HubConnectionBuilder()
          .withUrl(this.transactionUploadsHub, {
            accessTokenFactory: () => idToken,
          })
          .withAutomaticReconnect()
          .build();

        this.transactionUploadsConnection.on('ReceiveTransactionUploadsStatus', (data) => {
          this.transactionUploads.next(
            data.transaction_uploads.map((u) => {
              u.status_details_parsed = JSON.parse(u.status_details);
              return u;
            }),
          );
          console.log(data.transaction_uploads);
        });

        await this.transactionUploadsConnection.start({ withCredentials: true });
        this.transactionUploadsConnected.next(true);

        console.log(`SignalR connection success! connectionId: ${this.transactionUploadsConnection.connectionId}`);
      } catch (error) {
        console.log(`SignalR connection error: ${error}`);
      }
    });
  }

  public getCurrentTransactionUploadsStatus() {
    return from(this.transactionUploadsConnection.send('GetTransactionUploadsStatus'));
  }
}
